import axios from "axios";
import { XMLParser } from 'fast-xml-parser';
import OWM from "./OpenWeatherMap";
import { API_URL } from "./API";

const url = 'http://servicos.cptec.inpe.br/XML/listaCidades?'
//http://servicos.cptec.inpe.br/XML/cidade/-22.71/-45.11/estendidaLatLon.xml
//http://servicos.cptec.inpe.br/XML/cidade/7dias/-22.90/-47.06/previsaoLatLon.xml
const parser = new XMLParser();

// Sigla	Descrição
// ec	Encoberto com Chuvas Isoladas
// ci	Chuvas Isoladas
// c	Chuva
// in	Instável
// pp	Poss. de Pancadas de Chuva
// cm	Chuva pela Manhã
// cn	Chuva a Noite
// pt	Pancadas de Chuva a Tarde
// pm	Pancadas de Chuva pela Manhã
// np	Nublado e Pancadas de Chuva
// pc	Pancadas de Chuva
// pn	Parcialmente Nublado
// cv	Chuvisco
// ch	Chuvoso
// t	Tempestade
// ps	Predomínio de Sol
// e	Encoberto
// n	Nublado
// cl	Céu Claro
// nv	Nevoeiro
// g	Geada
// ne	Neve
// nd	Não Definido
// pnt	Pancadas de Chuva a Noite
// psc	Possibilidade de Chuva
// pcm	Possibilidade de Chuva pela Manhã
// pct	Possibilidade de Chuva a Tarde
// pcn	Possibilidade de Chuva a Noite
// npt	Nublado com Pancadas a Tarde
// npn	Nublado com Pancadas a Noite
// ncn	Nublado com Poss. de Chuva a Noite
// nct	Nublado com Poss. de Chuva a Tarde
// ncm	Nubl. c/ Poss. de Chuva pela Manhã
// npm	Nublado com Pancadas pela Manhã
// npp	Nublado com Possibilidade de Chuva
// vn	Variação de Nebulosidade
// ct	Chuva a Tarde
// ppn	Poss. de Panc. de Chuva a Noite
// ppt	Poss. de Panc. de Chuva a Tarde
// ppm	Poss. de Panc. de Chuva pela Manhã
enum OWM_Description {
    ec = 'Encoberto com Chuvas Isoladas',
    ci = 'Chuvas Isoladas',
    c = 'Chuva',
    in = 'Instável',
    pp = 'Possibilidade de Pancadas de Chuva',
    cm = 'Chuva pela Manhã',
    cn = 'Chuva a Noite',
    pt = 'Pancadas de Chuva a Tarde',
    pm = 'Pancadas de Chuva pela Manhã',
    np = 'Nublado e Pancadas de Chuva',
    pc = 'Pancadas de Chuva',
    pn = 'Parcialmente Nublado',
    cv = 'Chuvisco',
    ch = 'Chuvoso',
    t = 'Tempestade',
    ps = 'Predomínio de Sol',
    e = 'Encoberto',
    n = 'Nublado',
    cl = 'Céu Claro',
    nv = 'Nevoeiro',
    g = 'Geada',
    ne = 'Neve',
    nd = 'Não Definido',
    pnt = 'Pancadas de Chuva a Noite',
    psc = 'Possibilidade de Chuva',
    pcm = 'Possibilidade de Chuva pela Manhã',
    pct = 'Possibilidade de Chuva a Tarde',
    pcn = 'Possibilidade de Chuva a Noite',
    npt = 'Nublado com Pancadas a Tarde',
    npn = 'Nublado com Pancadas a Noite',
    ncn = 'Nublado com Possibilidade de Chuva a Noite',
    nct = 'Nublado com Possibilidade de Chuva a Tarde',
    ncm = 'Nublado com Possibilidade de Chuva pela Manhã',
    npm = 'Nublado com Pancadas pela Manhã',
    npp = 'Nublado com Possibilidade de Chuva',
    vn = 'Variação de Nebulosidade',
    ct = 'Chuva a Tarde',
    ppn = 'Poss. de Panc. de Chuva a Noite',
    ppt = 'Poss. de Panc. de Chuva a Tarde',
    ppm = 'Poss. de Panc. de Chuva pela Manhã',
}
const getWeatherIcon = (cptec: keyof typeof OWM_Description, night: boolean = false): string => {
    switch (cptec) {
        case 'ec': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'ci': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'c': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'in': return night ? OWM.WEATHER_ICONS.NoiteTrovoada : OWM.WEATHER_ICONS.Trovoada;
        case 'pp': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'cm': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'cn': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'pt': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'pm': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'np': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'pc': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'pn': return night ? OWM.WEATHER_ICONS.NoiteParcialmenteNublada : OWM.WEATHER_ICONS.ParcialmenteNublado;
        case 'cv': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'ch': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 't': return night ? OWM.WEATHER_ICONS.NoiteTrovoada : OWM.WEATHER_ICONS.Trovoada;
        case 'ps': return night ? OWM.WEATHER_ICONS.NoiteLimpa : OWM.WEATHER_ICONS.Ensolarado;
        case 'e': return night ? OWM.WEATHER_ICONS.NoiteNublada : OWM.WEATHER_ICONS.Nublado;
        case 'n': return night ? OWM.WEATHER_ICONS.NoiteNublada : OWM.WEATHER_ICONS.Nublado;
        case 'cl': return night ? OWM.WEATHER_ICONS.NoiteLimpa : OWM.WEATHER_ICONS.Ensolarado;
        case 'nv': return night ? OWM.WEATHER_ICONS.NoiteNevoeiro : OWM.WEATHER_ICONS.Nevoeiro;
        case 'g': return night ? OWM.WEATHER_ICONS.NoiteNeve : OWM.WEATHER_ICONS.Neve; // Geada não tem ícone, usando neve
        case 'ne': return night ? OWM.WEATHER_ICONS.NoiteNeve : OWM.WEATHER_ICONS.Neve;
        case 'nd': return ''
        case 'pnt': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'psc': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'pcm': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'pct': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'pcn': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'npt': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'npn': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'ncn': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'nct': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'ncm': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'npm': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'npp': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'vn': return night ? OWM.WEATHER_ICONS.NoiteParcialmenteNublada : OWM.WEATHER_ICONS.ParcialmenteNublado;
        case 'ct': return night ? OWM.WEATHER_ICONS.NoiteChuva : OWM.WEATHER_ICONS.Chuva;
        case 'ppn': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'ppt': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        case 'ppm': return night ? OWM.WEATHER_ICONS.NoiteChuvaFraca : OWM.WEATHER_ICONS.ChuvaFraca;
        default:
            return ''
    }
}
export type CPTEC_Forecast = {
    nome: string; // City name
    uf: string; // State code
    atualizacao: string; // Last update date
    previsao: Array<CPTEC_Prediction>; // Array of predictions
}
export enum CPTEC_Description {
    ec = 'Encoberto com Chuvas Isoladas',
    ci = 'Chuvas Isoladas',
    c = 'Chuva',
    in = 'Instável',
    pp = 'Possibilidade de Pancadas de Chuva',
    cm = 'Chuva pela Manhã',
    cn = 'Chuva a Noite',
    pt = 'Pancadas de Chuva a Tarde',
    pm = 'Pancadas de Chuva pela Manhã',
    np = 'Nublado e Pancadas de Chuva',
    pc = 'Pancadas de Chuva',
    pn = 'Parcialmente Nublado',
    cv = 'Chuvisco',
    ch = 'Chuvoso',
    t = 'Tempestade',
    ps = 'Predomínio de Sol',
    e = 'Encoberto',
    n = 'Nublado',
    cl = 'Céu Claro',
    nv = 'Nevoeiro',
    g = 'Geada',
    ne = 'Neve',
    nd = 'Não Definido',
    pnt = 'Pancadas de Chuva a Noite',
    psc = 'Possibilidade de Chuva',
    pcm = 'Possibilidade de Chuva pela Manhã',
    pct = 'Possibilidade de Chuva a Tarde',
    pcn = 'Possibilidade de Chuva a Noite',
    npt = 'Nublado com Pancadas a Tarde',
    npn = 'Nublado com Pancadas a Noite',
    ncn = 'Nublado com Poss. de Chuva a Noite',
    nct = 'Nublado com Poss. de Chuva a Tarde',
    ncm = 'Nubl. c/ Poss. de Chuva pela Manhã',
    npm = 'Nublado com Pancadas pela Manhã',
    npp = 'Nublado com Possibilidade de Chuva',
    vn = 'Variação de Nebulosidade',
    ct = 'Chuva a Tarde',
    ppn = 'Poss. de Panc. de Chuva a Noite',
    ppt = 'Poss. de Panc. de Chuva a Tarde',
    ppm = 'Poss. de Panc. de Chuva pela Manhã',
}
export type CPTEC_Prediction = {
    dia: string; // Date in YYYY-MM-DD format
    tempo: keyof typeof CPTEC_Description; // Weather condition code (e.g., 'pn' for partially cloudy)
    maxima: number; // Maximum temperature
    minima: number; // Minimum temperature
    iuv: number;
}
const previsao = async (lat: number, lon: number) => {
    try {
        // const url = `https://api.monitorabahia.gearspark.com.br/api/proxy/cptec/?lat=${lat}&lon=${lon}`;
        const url = `${API_URL}proxy/cptec/?lat=${lat}&lon=${lon}`;
        // const url = `http://servicos.cptec.inpe.br/XML/cidade/7dias/${lat}/${lon}/previsaoLatLon.xml`;
        const data = (await axios.get(url)).data
        const parsedData = parser.parse(data);
        // console.log('Dados parseados:', parsedData);
        return parsedData.cidade as CPTEC_Forecast;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('Erro ao consultar previsão do tempo (Axios):', {
                message: error.message,
                code: error.code,
                status: error.response?.status,
                data: error.response?.data
            });
        } else {
            console.error('Erro ao consultar previsão do tempo:', error);
        }
        return {
            nome: '',
            uf: '',
            atualizacao: '',
            previsao: []
        };
    }

}
const isToday = (date: Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date.getTime() === today.getTime();
}
const isTomorrow = (date: Date) => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date.getTime() === tomorrow.getTime();
}

const dia = (date: Date) => {
    // const date = new Date(data)
    date.setHours(0, 0, 0, 0)

    if (isToday(date)) {
        return 'Hoje';
    }

    if (isTomorrow(date)) {
        return 'Amanhã';
    }

    return date.toLocaleDateString('pt-BR', {
        weekday: 'short',
        day: 'numeric',
        // month: 'long'
    });
}
const CPTEC = {
    url,
    dia,
    isToday,
    isTomorrow,
    previsao,
    getWeatherIcon,
    CPTEC_Description
}
export default CPTEC;